import { ActiveTabTypeE } from 'declarations/enums/tab';
import type { Column } from 'declarations/types/common';

/** Column ids excluded from Schedule section (table and column picker). */
export const SCHEDULE_EXCLUDED_COLUMN_IDS = ['1', '9', '13', '14', '15', '16']; // P, Category, Advisor, Tech, Attachment, Approved

/** Column ids excluded from Tickets section (never show in list view or customize modal). */
export const TICKET_EXCLUDED_COLUMN_IDS = ['19', '23', '24']; // Account, Chirp, Work Type (schedule only)

export const STORAGE_KEY_SCHEDULE = 'visibleColumns_schedule';
export const STORAGE_KEY_TICKETS = 'visibleColumns_tickets';

export function getStorageKeyForSection(activeTab: ActiveTabTypeE): string {
  return activeTab === ActiveTabTypeE.Schedule ? STORAGE_KEY_SCHEDULE : STORAGE_KEY_TICKETS;
}

export function getColumnsForSection(activeTab: ActiveTabTypeE): Column[] {
  if (activeTab === ActiveTabTypeE.Schedule) {
    return columns.filter(col => !SCHEDULE_EXCLUDED_COLUMN_IDS.includes(col.id));
  }
  return columns.filter(col => !TICKET_EXCLUDED_COLUMN_IDS.includes(col.id));
}

export const columns: Column[] = [
  { id: '1', label: 'P', visible: true, isRequired: false },
  { id: '2', label: 'RO', visible: true, isRequired: true },
  { id: '3', label: 'Line', visible: true, isRequired: false },
  { id: '4', label: 'Status', visible: true, isRequired: true },
  { id: '5', label: 'Age', visible: true, isRequired: false },
  { id: '6', label: 'Claim Age', visible: true, isRequired: false },
  { id: '7', label: 'Assignee', visible: true, isRequired: true },
  { id: '9', label: 'Category', visible: true, isRequired: true },
  { id: '10', label: 'Last Comment', visible: true, isRequired: false },
  { id: '11', label: 'Claim Status', visible: true, isRequired: false },
  { id: '12', label: 'Amount', visible: true, isRequired: false },
  { id: '13', label: 'Advisor', visible: true, isRequired: false },
  { id: '14', label: 'Tech', visible: true, isRequired: false },
  { id: '21', label: 'VIN', visible: true, isRequired: false },
  { id: '15', label: 'Attachment', visible: true, isRequired: false },
  { id: '16', label: 'Approved', visible: true, isRequired: false },
  { id: '17', label: 'Subcategory', visible: true, isRequired: false },
  { id: '18', label: 'Closed RO Age', visible: true, isRequired: false },
  { id: '19', label: 'Account', visible: true, isRequired: false },
  { id: '20', label: 'Audit Trail', visible: true, isRequired: false },
  { id: '22', label: 'Closed RO Date', visible: true, isRequired: false },
  { id: '23', label: 'Chirp', visible: true, isRequired: false },
  { id: '24', label: 'Work Type', visible: true, isRequired: false },
];
